import React from 'react';
import { Plus, Search, Map, Target, Settings, MoreVertical, MapPin, Building2, TrendingUp } from 'lucide-react';
import { LensVersion } from '../types';
export function MarketLensesSection({
  lensVersions,
  onOpenLens,
  onNewLens
}: {
  lensVersions: LensVersion[];
  onOpenLens?: (id: string) => void;
  onNewLens?: () => void;
}) {
  const hasLens = lensVersions.length > 0;
  return <div className="w-full max-w-5xl mx-auto px-6 pb-12" data-id="element-617">
      <div className="flex items-center justify-between mb-6" data-id="element-618">
        <h3 className="text-lg font-semibold text-gray-900" data-id="element-619">
          Your Market Lenses
        </h3>
        <button onClick={onNewLens} className="flex items-center text-teal-600 hover:text-teal-700 font-medium text-sm transition-colors" data-id="element-620">
          <Plus size={16} className="mr-1" data-id="element-621" />
          New Market Lens
        </button>
      </div>

      {hasLens ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-622">
          {lensVersions.map(lens => <button key={lens.id} onClick={() => onOpenLens?.(lens.id)} className="bg-white rounded-2xl shadow-sm border border-gray-200 p-6 text-left hover:shadow-md hover:border-gray-300 transition-all group" data-id="element-623">
              <div className="flex items-start justify-between mb-4" data-id="element-624">
                <div className="w-10 h-10 bg-indigo-50 rounded-lg flex items-center justify-center" data-id="element-625">
                  <Search size={18} className="text-indigo-500" data-id="element-626" />
                </div>
                <button onClick={e => e.stopPropagation()} className="p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-md transition-colors opacity-0 group-hover:opacity-100" data-id="element-627">
                  <MoreVertical size={16} data-id="element-628" />
                </button>
              </div>

              <h4 className="text-lg font-bold text-gray-900 mb-1 truncate" data-id="element-629">
                {lens.name}
              </h4>
              <p className="text-sm text-gray-500 mb-3 truncate" data-id="element-630">
                {lens.lensData.netWorth.min || '$0'} NW •{' '}
                {lens.lensData.states.length > 0 ? lens.lensData.states[0] : 'All States'}
              </p>
              <p className="text-sm text-gray-600 leading-relaxed mb-4 line-clamp-2" data-id="element-631">
                Market lens targeting{' '}
                {lens.lensData.careers.length > 0 ? lens.lensData.careers.join(', ') : 'various professionals'}{' '}
                with {lens.lensData.assets.min || 'any'} in investable assets.
              </p>

              <div className="flex flex-wrap gap-2" data-id="element-632">
                {lens.lensData.states.slice(0, 1).map(state => <span key={state} className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-teal-50 text-teal-700 border border-teal-100" data-id="element-633">
                    <MapPin size={12} className="mr-1" data-id="element-634" />
                    {state}
                  </span>)}
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-teal-50 text-teal-700 border border-teal-100" data-id="element-635">
                  <Building2 size={12} className="mr-1" data-id="element-636" />
                  95K Households
                </span>
                <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-teal-50 text-teal-700 border border-teal-100" data-id="element-637">
                  <TrendingUp size={12} className="mr-1" data-id="element-638" />
                  +18% Growth
                </span>
              </div>
            </button>)}
        </div> : <div className="bg-white rounded-2xl shadow-sm border border-gray-200 p-12 text-center flex flex-col items-center justify-center" data-id="element-639">
          <div className="w-16 h-16 bg-gray-50 rounded-full flex items-center justify-center mb-4" data-id="element-640">
            <Search size={24} className="text-gray-400" data-id="element-641" />
          </div>
          <h4 className="text-lg font-bold text-gray-900 mb-2" data-id="element-642">
            No Market Lenses yet
          </h4>
          <p className="text-gray-500 max-w-md mb-6" data-id="element-643">
            Create your first Market Lens to start analyzing your target
            audience and discovering new opportunities.
          </p>
          <button onClick={onNewLens} className="flex items-center bg-teal-600 hover:bg-teal-700 text-white font-medium px-5 py-2.5 rounded-lg transition-colors" data-id="element-644">
            <Plus size={18} className="mr-2" data-id="element-645" />
            Create Market Lens
          </button>
        </div>}
    </div>;
}